export const EVENTS = {
  SIGN_UPS: '#SignUps',
  LOGIN: '#Logins',
  COMPLETED_PROFILE: '#CompletedProfiles',
};
